"use strict";
exports.__esModule = true;
exports.CancelConditionType = exports.RateQualifierType = exports.RateDepositType = void 0;
var RateDepositType;
(function (RateDepositType) {
    RateDepositType["PercentageWithoutExtras"] = "PercentageWithoutExtras";
    RateDepositType["FirstNightWithoutExtras"] = "FirstNightWithoutExtras";
})(RateDepositType = exports.RateDepositType || (exports.RateDepositType = {}));
var RateQualifierType;
(function (RateQualifierType) {
    RateQualifierType["RoomOnly"] = "RoomOnly";
    RateQualifierType["BreakfastIncluded"] = "BreakfastIncluded";
    RateQualifierType["HalfBoard"] = "HalfBoard";
    RateQualifierType["FullBoard"] = "FullBoard";
    RateQualifierType["AllInclusive"] = "AllInclusive";
    RateQualifierType["SelfCatering"] = "SelfCatering";
    RateQualifierType["Package"] = "Package";
    RateQualifierType["BreakfastIncludedPackage"] = "BreakfastIncludedPackage";
    RateQualifierType["HalfBoardPackage"] = "HalfBoardPackage";
    RateQualifierType["FullBoardPackage"] = "FullBoardPackage";
    RateQualifierType["AllInclusivePackage"] = "FullBoardPackage";
    RateQualifierType["SelfCateringPackage"] = "SelfCateringPackage";
})(RateQualifierType = exports.RateQualifierType || (exports.RateQualifierType = {}));
var CancelConditionType;
(function (CancelConditionType) {
    CancelConditionType["Short"] = "Short";
    CancelConditionType["Default"] = "Default";
})(CancelConditionType = exports.CancelConditionType || (exports.CancelConditionType = {}));
//# sourceMappingURL=rate.model.js.map